import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=3631c797&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Navigation.vue?vue&type=style&index=1&id=3631c797&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631c797",
  null
  
)

export default component.exports